import product1Image from "./product1.png";
import product2Image from "./product2.png";
import product3Image from "./product3.png";

export { product1Image, product2Image, product3Image };
